/**
 * Largest picture, in pixels, the picker agrees to open. Mirrors the mobile picker and the
 * backend (`MAX_UPLOAD_PIXELS` in both).
 *
 * Opening is the expensive part, not uploading: a progressive JPEG is decoded in full before it
 * can be scaled, so the 29437x10751 panorama that took the staging feed down costs ~1.9GB in any
 * decoder, a browser's included — and past ~16MP Safari will not even draw it to a canvas. 64MP
 * clears a 50MP phone capture and stops stitched panoramas and 108MP/200MP modes.
 */
export const MAX_UPLOAD_PIXELS = 64_000_000

/** Longest edge a cropped picture is exported at — what the mobile app uploads too. */
export const MAX_UPLOAD_EDGE = 1600

export const UPLOAD_QUALITY = 0.8

export function isWithinPixelBudget(width: number, height: number) {
  return width * height <= MAX_UPLOAD_PIXELS
}

/** `width`x`height` scaled down so neither side passes `MAX_UPLOAD_EDGE`. Never scales up. */
export function boundedSize(width: number, height: number) {
  const scale = Math.min(1, MAX_UPLOAD_EDGE / Math.max(width, height))

  return { width: Math.round(width * scale), height: Math.round(height * scale) }
}
